import { stores } from '../../stores';
import compact from 'lodash/compact';
import { media } from '../../stores/media/media';
import { useStore } from '../useStore';
import { translate } from '../../services/translate';
import { getRoute } from '../../services/router';
import { isFeatureAvailable } from '../../services/feature';
import { FEATURE } from '../../services/types';
import { isUserFromCountry } from '../../services/users/country';
import { Country } from '@staycool/location';
import { isBYOD } from '../../services/environment';

export function useSportLobbyCategoriesLinks() {
    const [{ isPhone, isTablet }] = useStore(media);
    const [isOfficeIp] = useStore(stores.isOfficeIp);
    const isMainNavigationV2 = isFeatureAvailable(FEATURE.SPORT_MAIN_NAVIGATION_V2);

    const links = compact([
        {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.sports-lobby.short')
                    : translate('sports.navigation.sports-lobby'),
            route: getRoute('sport.recommendations'),
            icon: isMainNavigationV2 ? 'football' : 'sports-ico',
        },
        {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.livebet-lobby.short')
                    : translate('sports.navigation.livebet-lobby'),
            route: getRoute('sport.live'),
            icon: isMainNavigationV2 ? 'poker-live-games' : 'live-stream',
        },
        isMainNavigationV2 && {
            route: getRoute('sport.favorites'),
            icon: 'star',
            label: translate('favorites', 'ui.sportsbook'),
        },
        isMainNavigationV2 && {
            route: getRoute('sport.bet-history'),
            icon: 'bethistory-ico',
            label: translate('My bets', 'ui.sportsbook'),
        },
        !isBYOD() &&
            isFeatureAvailable(FEATURE.PARLAY_CARD) && {
                route: getRoute('sport.parlay-cards'),
                icon: 'parley-card',
                label: translate('Parlay Cards', 'ui.sportsbook'),
            },
        isFeatureAvailable(FEATURE.INCOMING_BETS) && {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.incoming-bets-button.short')
                    : translate('sports.navigation.incoming-bets-button'),
            route: getRoute('sport.incoming-bets'),
            icon: isMainNavigationV2 ? 'combo-generator' : 'incoming-bets',
        },
        isFeatureAvailable(FEATURE.CONTESTS) && {
            route: getRoute('sport.contests'),
            icon: 'casino-race',
            label: translate('Contests', 'ui.contest'),
        },
        isFeatureAvailable(FEATURE.VIRTUAL_SPORTS) && {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.virtual-sport-button.short')
                    : translate('sports.navigation.virtual-sport-button'),
            route: getRoute('virtual-sports'),
            icon: 'virtual-sports',
        },
        isFeatureAvailable(FEATURE.LEAGUE) && {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.league-button.short')
                    : translate('sports.navigation.league-button'),
            route: getRoute('league'),
            icon: 'coolbet-league',
        },
        isFeatureAvailable(FEATURE.WINNERS_FEED) && {
            label:
                isPhone || isTablet
                    ? translate('sports.navigation.winners-feed-button.short')
                    : translate('sports.navigation.winners-feed-button'),
            route: getRoute('sport.winners-feed'),
            icon: isMainNavigationV2 ? 'crown' : 'trophy',
        },
        isFeatureAvailable(FEATURE.CAMPAIGN_WINNERS) &&
            isUserFromCountry(Country.FINLAND) &&
            isOfficeIp && {
                label: translate('sports.navigation.campaign-winners'),
                route: getRoute('sport.campaign-winners'),
                icon: 'trophy',
            },
    ]);

    return links;
}
